import { AuthConfig } from "@auth0/auth0-angular";
import { environment } from "src/environments/environment";

export const genAuthConfig: AuthConfig = {
  domain: environment.domain,
  clientId: environment.clientId,
  authorizationParams: {
    redirect_uri: window.location.origin + '/login',
    audience: 'api://sapcommerce.auth0',
    scope: 'openid profile email invoke:api',
  },
  cacheLocation: "localstorage",
};